import { render, staticRenderFns } from "./PaginationComponent.vue?vue&type=template&id=7b12fed7&scoped=true&"
import script from "./PaginationComponent.vue?vue&type=script&lang=js&"
export * from "./PaginationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b12fed7",
  null
  
)

export default component.exports